// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__CmmFm","rootMobile":"styles_rootMobile__2SXhh"};